import { request } from "store/api/organization/accountGet/accountGetActions";
import { useResource } from "./useResource";

export function useAccount() {
  return useResource("accountGet", request);
}
